import React, { Component } from "react";
import { Link } from "react-router-dom";
// import logo from "../assets/images/logo3.svg";
import logo from "../assets/images/new-logo.svg";
import { withRouter } from "react-router-dom";
import { logOut } from "../store/actions/homeActions";
import { connect } from "react-redux";

import { compose } from "redux";

import onClickOutside from 'react-onclickoutside'

import { languageService } from "../pages/lang/Lang.js";




class Links extends Component {
  state = {
    toggled: false,
    languageDropdownOpen: false,
    currentLanguage: 'en',
  };

  componentDidMount() {
    this.setState({
      currentLanguage: languageService.getLanguage() || 'en'
    });
  }

  handleClickOutside = (event) => {
    //alert('onClickOutside() method called');
    // Don't close language dropdown if clicking inside it
    if (this.languageSelectorRef && this.languageSelectorRef.contains(event.target)) {
      return;
    }
    let ref = "diocane";
    this.refs[ref].checked = false;
    this.setState({ languageDropdownOpen: false });
  }

  toggleLanguageDropdown = (e) => {
    if (e && e.currentTarget) {
      const rect = e.currentTarget.getBoundingClientRect();
      const dropdownWidth = 200; // minWidth of dropdown

      // Calculate left position, ensuring it doesn't go off screen
      let leftPosition = rect.right - dropdownWidth;

      // If it goes off the left edge, adjust it
      if (leftPosition < 10) {
        leftPosition = 10; // 10px margin from left edge
      }

      // If it goes off the right edge, adjust it
      if (leftPosition + dropdownWidth > window.innerWidth - 10) {
        leftPosition = window.innerWidth - dropdownWidth - 10;
      }

      this.setState(prevState => ({
        languageDropdownOpen: !prevState.languageDropdownOpen,
        dropdownPosition: {
          top: rect.bottom + window.scrollY,
          left: leftPosition
        }
      }));
    } else {
      this.setState(prevState => ({
        languageDropdownOpen: !prevState.languageDropdownOpen
      }));
    }
  }

  changeLanguage = (lang) => {
    languageService.setLanguage(lang);
    this.setState({
      currentLanguage: lang,
      languageDropdownOpen: false
    });
    setTimeout(() => {
      window.location.href = "/";
    }, 300);
  }


  handleChange = (e) => {
    this.setState({
      toggled: e.target.checked,
    });
  };

  oii = () => {
    if (this.state.toggled) {
      let ref = "diocane";
      this.refs[ref].checked = !this.refs[ref].checked;
    }
  };

  oii2 = () => {
    let ref = "diocane";
    this.refs[ref].checked = false;
  };

  getLanguageCode = (lang) => {
    const codes = {
      'en': 'GB',
      'de': 'DE',
      'it': 'IT',
      'ar': 'AR',
      'es': 'ES',
      'fr': 'FR',
      'bg': 'BG',
      'sr': 'RS'
    };
    return codes[lang] || 'GB';
  }

  getLanguageName = (lang) => {
    const names = {
      'en': 'English',
      'de': 'Deutsch',
      'it': 'Italiano',
      'ar': 'العربية',
      'es': 'Español',
      'fr': 'Français',
      'bg': 'Български',
      'sr': 'Српски'
    };
    return names[lang] || 'English';
  }

  getLanguageShortName = (lang) => {
    const shortNames = {
      'en': 'EN',
      'de': 'DE',
      'it': 'IT',
      'ar': 'AR',
      'es': 'ES',
      'fr': 'FR',
      'bg': 'BG',
      'sr': 'SR'
    };
    return shortNames[lang] || 'EN';
  }

  renderLanguageSelector = () => {
    const { languageDropdownOpen, currentLanguage, dropdownPosition } = this.state;
    const languages = [
      { code: 'en', countryCode: 'GB', name: 'English' },
      { code: 'de', countryCode: 'DE', name: 'Deutsch' },
      { code: 'it', countryCode: 'IT', name: 'Italiano' },
      { code: 'ar', countryCode: 'AR', name: 'العربية' },
      { code: 'es', countryCode: 'ES', name: 'Español' },
      { code: 'fr', countryCode: 'FR', name: 'Français' },
      { code: 'bg', countryCode: 'BG', name: 'Български' },
      { code: 'sr', countryCode: 'RS', name: 'Српски' }
    ];

    // Detect if mobile (screen width < 1024px, which is Bulma's tablet breakpoint)
    const isMobile = typeof window !== 'undefined' && window.innerWidth < 1024;

    return (
      <div
        ref={(el) => this.languageSelectorRef = el}
        style={{
          position: 'relative',
          display: 'inline-block',
          marginLeft: '15px'
        }}
      >
        <button
          onClick={(e) => {
            e.stopPropagation();
            this.toggleLanguageDropdown(e);
          }}
          style={{
            background: '#fff',
            border: '2px solid #F35875',
            borderRadius: '25px',
            padding: '8px 20px',
            cursor: 'pointer',
            fontSize: '0.95rem',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            transition: 'all 0.3s ease',
            color: '#3C2200',
            fontWeight: '600',
            letterSpacing: '0.5px'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#F35875';
            e.currentTarget.style.color = '#fff';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#fff';
            e.currentTarget.style.color = '#3C2200';
          }}
        >
          <span>{this.getLanguageCode(currentLanguage)}</span>
          {currentLanguage === 'en' && <span>{this.getLanguageShortName(currentLanguage)}</span>}
          <span style={{ fontSize: '0.7rem' }}>{languageDropdownOpen ? '▲' : '▼'}</span>
        </button>

        {languageDropdownOpen && (
          <div style={{
            position: isMobile ? 'fixed' : 'absolute',
            top: isMobile && dropdownPosition ? `${dropdownPosition.top + 10}px` : '100%',
            left: isMobile && dropdownPosition ? `${dropdownPosition.left}px` : 'auto',
            right: isMobile ? 'auto' : '0',
            marginTop: isMobile ? '0' : '10px',
            background: '#fff',
            border: '1px solid #E5E5E5',
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            zIndex: 99999,
            minWidth: '200px',
            overflow: 'visible',
            padding: '8px 0'
          }}>
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={(e) => {
                  e.stopPropagation();
                  this.changeLanguage(lang.code);
                }}
                style={{
                  width: '100%',
                  padding: '12px 20px',
                  border: 'none',
                  background: '#fff',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  fontSize: '0.95rem',
                  color: currentLanguage === lang.code ? '#2D7FF9' : '#3C2200',
                  transition: 'background 0.2s ease',
                  textAlign: 'left',
                  fontWeight: currentLanguage === lang.code ? '600' : '400'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgb(233, 244, 255)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '#fff';
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <span style={{ fontWeight: '600', minWidth: '30px' }}>{lang.countryCode}</span>
                  <span>{lang.name}</span>
                </div>
                {currentLanguage === lang.code && (
                  <span style={{ color: '#2D7FF9', fontSize: '1.2rem' }}>✓</span>
                )}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }

  // console.log(this.props.location);

  render() {
    //console.log(this.props.location.pathname);


    return this.props.location.pathname !== "/login" && this.props.loggedin ? (
      <nav
        className={`navbar is-fixed-top ${this.state.scrollTop >= 30 ? "shadow-active" : ""
          }`}
        role="navigation"
        aria-label="main navigation"
      >
        <div className="container">
          <div className="navbar-brand">
            <Link className="navbar-item" onClick={this.oii2} to="/">
              <img src={logo} className="logonav" alt="Sahra's logo" />
            </Link>
            <label
              role="button"
              className="navbar-burger burger"
              aria-label="menu"
              aria-expanded="false"
              htmlFor="nav-toggle-state"
            >
              <span aria-hidden="true" />
              <span aria-hidden="true" />
              <span aria-hidden="true" />
            </label>
          </div>
          <input
            ref={"diocane"}
            type="checkbox"
            id="nav-toggle-state"
            onChange={this.handleChange}
          />
          <div id="navbarBasicExample" className="navbar-menu">
            <div className="navbar-end">


              <Link
                className={
                  this.props.location.pathname.startsWith("/mesaggi")
                    ? "navbar-item blogle boldme"
                    : "navbar-item blogle"
                }

                onClick={this.oii}
                to="/chat"

              >
                {languageService.translate('links.t1')}
              </Link>




              <Link
                className={
                  this.props.location.pathname.startsWith("/mesaggi")
                    ? "navbar-item blogle boldme"
                    : "navbar-item blogle"
                }

                onClick={this.oii}
                to="/settings"

              >
                {languageService.translate('links.t2')}
              </Link>





              <Link
                className={
                  this.props.location.pathname.startsWith("/mesaggi")
                    ? "navbar-item blogle boldme"
                    : "navbar-item blogle"
                }

                onClick={() => {
                  this.props.logOut();
                  window.location.href = "/";
                }}

                to="/"

              >
                {languageService.translate('links.t3')}
              </Link>

              {this.renderLanguageSelector()}

            </div>
          </div>
        </div>
      </nav>
    ) : (
      <nav
        className={`navbar is-fixed-top ${this.state.scrollTop >= 30 ? "shadow-active" : ""
          }`}
        role="navigation"
        aria-label="main navigation"
      >
        <div className="container">
          <div className="navbar-brand">
            <Link className="navbar-item" onClick={this.oii2} to="/">
              <img src={logo} className="logonav" alt="Sahra's logo" />
            </Link>
            <label
              role="button"
              className="navbar-burger burger"
              aria-label="menu"
              aria-expanded="false"
              htmlFor="nav-toggle-state"
            >
              <span aria-hidden="true" />
              <span aria-hidden="true" />
              <span aria-hidden="true" />
            </label>
          </div>
          <input
            ref={"diocane"}
            type="checkbox"
            id="nav-toggle-state"
            onChange={this.handleChange}
          />
          <div id="navbarBasicExample" className="navbar-menu">
            <div className="navbar-end">


              <Link
                className={
                  this.props.location.pathname.startsWith("/mesaggi")
                    ? "navbar-item blogle boldme"
                    : "navbar-item blogle"
                }

                onClick={() => {
                  

                  window.scrollTo({ top: 150, behavior: 'smooth' });
                  this.oii();

                }}
                to="/"


              >
                {languageService.translate('links.t4')}
              </Link>





              <Link
                className={
                  this.props.location.pathname.startsWith("/mesaggi")
                    ? "navbar-item blogle boldme"
                    : "navbar-item blogle"
                }

                onClick={() => {
                  this.oii();

                  // If already on home page, scroll immediately
                  if (this.props.location.pathname === '/') {
                    setTimeout(() => {
                      const faqSection = document.getElementById('faq-section');
                      if (faqSection) {
                        faqSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      }
                    }, 100);
                  } else {
                    // If on another page, wait for navigation then scroll
                    setTimeout(() => {
                      const faqSection = document.getElementById('faq-section');
                      if (faqSection) {
                        faqSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      }
                    }, 300);
                  }
                }}

                to="/"

              >
                F.A.Q.
              </Link>


              <a
                className={
                  this.props.location.pathname.startsWith("/mesaggi")
                    ? "navbar-item blogle boldme"
                    : "navbar-item blogle"
                }

                href="mailto:hello@sahra.ai"
                onClick={()=>this.oii()}

              >
                {languageService.translate('links.t5')}
              </a>


              <Link
                className={
                  this.props.location.pathname.startsWith("/mesaggi")
                    ? "navbar-item blogle boldme"
                    : "navbar-item blogle"
                }
                onClick={this.oii}
                to="/login"

              >
                {languageService.translate('links.t1')}
              </Link>

              {this.renderLanguageSelector()}

            </div>
          </div>
        </div>
      </nav>
    )
  }
}




const mapStateToProps = (state) => {
  return {
    profile: state.home.profile,
    errore: state.home.erroreimpostazioni,
    loggedin: state.home.loggedin,
    userdata: state.home.userdata


  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logOut: () => dispatch(logOut()),
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(onClickOutside(Links));
